import api from './axios';

export const getTrustedCircleFilterOptionsApi = () =>
  api.get('/admin/trusted-circles/filter-options');
export const getTrustedCirclesApi = (params = {}) =>
  api.get('/admin/trusted-circles', { params });
export const getTrustedContactsApi = (params = {}) =>
  api.get('/admin/trusted-circles/contacts', { params });
export const getTrustedCircleApi = (circleId) =>
  api.get(`/admin/trusted-circles/${circleId}`);
export const updateTrustedCircleApi = (circleId, payload) =>
  api.put(`/admin/trusted-circles/${circleId}`, payload);
export const sendBulkRemindersApi = (circleId) =>
  api.post(`/admin/trusted-circles/${circleId}/reminder`);
export const addTrustedCircleMemberApi = (circleId, payload) =>
  api.post(`/admin/trusted-circles/${circleId}/members`, payload);
export const resendTrustedCircleInvitationApi = (circleId, memberId) =>
  api.post(`/admin/trusted-circles/${circleId}/members/${memberId}/resend`);
export const updateTrustedCircleMemberApi = (circleId, memberId, payload) =>
  api.put(`/admin/trusted-circles/${circleId}/members/${memberId}`, payload);
export const updateTrustedCircleMemberRoleApi = (circleId, memberId, payload) =>
  api.put(`/admin/trusted-circles/${circleId}/members/${memberId}/role`, payload);
export const removeTrustedCircleMemberApi = (circleId, memberId) =>
  api.delete(`/admin/trusted-circles/${circleId}/members/${memberId}`);
export const getTrustedCircleAnalyticsApi = (params = {}) =>
  api.get('/admin/trusted-circles/analytics/overview', { params });
